export const styles = {
  container: 'px-xl lg:rounded-xl lg:bg-neutral30 lg:p-2xl',
  text: 'text-center',
};
